import isValidParam from '../utils/isValidParam';
import isValidCheckoutQuery from '../utils/isValidCheckoutQuery';
import isValidResultsQuery from '../utils/isValidResultsQuery';
import store from '../store/index';
import * as DESTINIES_ACTIONS from "../store/destinies/action-types";
import { LOAD_GIFTS_LOCATIONS } from '../store/gifts/action-types';
import { GIFTS_FIND_DESTINATION_FROM_SLUG } from '../store/gifts/getter-types';
import { RETREIVE_RESERVATION } from '../store/booking/action-types';
import reserveAreaRoutes from './reserve-area';
import * as languages from "../../../public/lang/index";

const lang = window.appLocale || 'es';
const appConfig = window.appConfig || 'avm';

let routes = [
  {
    path: "/",
    name: "home",
    component: appConfig === 'avm'
      ? require("../pages/OneDayLanding.vue").default
      : require("../pages/PageHomeWhen.vue").default,
    meta: appConfig === 'avm'
      ? {
          title: languages.languages[lang].shared.avm_lower + ' - ' + languages.languages[lang].meta.one_day_travels.title,
          meta_title: languages.languages[lang].meta.one_day_travels.title,
          meta_description: languages.languages[lang].meta.one_day_travels.description,
          meta_keywords: languages.languages[lang].meta.one_day_travels.keywords
        }
      : {
          title: languages.languages[lang].meta.title_ebm + ' - ' + languages.languages[lang].meta.home.title,
          meta_title: languages.languages[lang].meta.home.title,
          meta_description: languages.languages[lang].meta.home.description,
          meta_keywords: languages.languages[lang].meta.meta_3 + languages.languages[lang].shared.ebm_upper + languages.languages[lang].meta.meta_4
        }
  },
  {
    path: "/:custom_url",
    name: "destination",
    component: require("../layouts/DestinationTravels.vue").default,
    meta: {
      dynamic: true,
    },
  },
  {
    path: "/vuelos-ida-y-vuelta-el-mismo-dia",
    name: "one-day",
    meta: {
      title: languages.languages[lang].shared.avm_lower + ' - ' + languages.languages[lang].meta.one_day_travels.title,
      meta_title: languages.languages[lang].meta.one_day_travels.title,
      meta_description: languages.languages[lang].meta.one_day_travels.description,
      meta_keywords: languages.languages[lang].meta.one_day_travels.keywords
    },
    component: require("../pages/OneDayLanding.vue").default
  },
  {
    path: "/viaje",
    component: require("../pages/PageBooking.vue").default,
    meta: appConfig === 'avm'
      ? {
          title: languages.languages[lang].shared.avm_lower + ' - ' + languages.languages[lang].meta.one_day_travels.title,

        }
      : {
          title: languages.languages[lang].meta.title_ebm + ' - ' + languages.languages[lang].meta.home.title,

    },
    children: [
      {
        path: "destinos",
        name: "destinies",
        meta: {
          title: languages.languages[lang].shared.avm_lower + ' - ' + languages.languages[lang].meta.destinations.title,
          meta_title: languages.languages[lang].shared.avm_lower + ' - ' + languages.languages[lang].meta.destinations.title,
          meta_description: languages.languages[lang].meta.destinations.description,
          meta_keywords: languages.languages[lang].meta.destinations.keywords,
        },
        component: require("../pages/DestinationsLanding.vue").default
      },
      {
        path: "destinos/:origin",
        name: "destinies-results",
        meta: {
          meta_title: languages.languages[lang].meta.meta_5 + languages.languages[lang].shared.avm_lower + languages.languages[lang].meta.meta_6,
          meta_description: languages.languages[lang].meta.meta_7 + languages.languages[lang].shared.avm_lower + languages.languages[lang].meta.meta_8,
          meta_keywords: languages.languages[lang].shared.avm_upper + languages.languages[lang].meta.meta_9
        },
        component: require("../modules/results/ResultsController.vue").default,
        beforeEnter: (to, from, next) => {
          if (to.params.origin && !isValidResultsQuery(to.query)) {
            next({ name: "404" });
          } else {
            next();
          }
        }
      },
      {
        path: "calendario/:origin/:destiny/",
        name: "calendar",
        props: true,
        component: require("../modules/calendar/CalendarController.vue").default
      },
      {
        path: "calendario/:origin/:destiny/pack",
        name: "calendar-pack",
        props: true,
        component: require("../modules/calendar/CalendarControllerPack.vue").default
      },
      {
        path: "checkout/:step",
        name: "checkout",
        props: true,
        component: require("../modules/booking/BookingController.vue").default,
        beforeEnter: (to, from, next) => {
          if (isValidParam(to.params.step) > -1 && isValidCheckoutQuery(to.query)) {
            next();
          } else {
            next({ name: "home-when" });
          }
        }
      },
      {
        path: ":reservationCode/confirmacion",
        name: "booking-confirmation",
        component: require("../pages/PageBookingConfirmation").default,
        beforeEnter: async (to, from, next) => {
          try {
            const reservation = await store.dispatch(RETREIVE_RESERVATION, to.params.reservationCode);
            if (!reservation) {
              throw new Error('Not found');
            }
            next();
          } catch {
            next({ name: 'home-when' })
          }
        }
      }
    ]
  },
  {
    path: "/mas-de-un-dia",
    component: require("../pages/PageBooking.vue").default,
    meta:{
      title: languages.languages[lang].meta.title_ebm + ' - ' + languages.languages[lang].meta.home.title,
    },
    children: [
      // Temporarily commented out to disable temporary more days trips
      // {
      //   path: "",
      //   name: "more-days",
      //   meta: {
      //     title: languages.languages[lang].shared.avm_lower +' - '+ languages.languages[lang].meta.more_than_one_day_travels.title,
      //     meta_title: languages.languages[lang].meta.more_than_one_day_travels.title,
      //     meta_description: languages.languages[lang].meta.more_than_one_day_travels.description,
      //     meta_keywords: languages.languages[lang].meta.more_than_one_day_travels.keywords
      //   },
      //   component: require("../pages/MoreDaysLanding.vue").default
      // },
      // {
      //   path: "destinos/:origin",
      //   name: "nights-destinations",
      //   meta: {
      //     meta_title: languages.languages[lang].meta.meta_5 + languages.languages[lang].shared.avm_lower + languages.languages[lang].meta.meta_6,
      //     meta_description: languages.languages[lang].meta.meta_7 + languages.languages[lang].shared.avm_lower + languages.languages[lang].meta.meta_8,
      //     meta_keywords: languages.languages[lang].shared.avm_upper + languages.languages[lang].meta.meta_9
      //   },
      //   component: require("../pages/nights/destinations/NightsDestinations.vue").default,
      // },
      {
        path: ":origin/:destination/checkout/:step",
        name: "nights-wizard",
        props: true,
        component: require("../pages/nights/NightsWizard.vue").default,
      },
      {
        path: ":reservationCode/confirmacion",
        name: "nights-confirmation",
        props: true,
        component: require("../pages/nights/confirmation/NightsConfirmation.vue").default,
        beforeEnter: async (to, from, next) => {
          try {
            const reservation = await store.dispatch(RETREIVE_RESERVATION, to.params.reservationCode);
            if (!reservation) {
              throw new Error('Not found');
            }
            next();
          } catch (error) {
            next({ name: 'home-when' })
          }
        }
      }
    ]
  },
  {
    path: "/destino/:slug",
    name: "destiny",
    component: require("../pages/destinies/DestinyLanding/DestinyLanding.vue").default,
    beforeEnter: async (to, from, next) => {
      store.dispatch(DESTINIES_ACTIONS.FETCH_PLACE, to.params.slug)
        .then(destination => {
          document.title = destination.meta_title || `Destino ${destination.name}`;
          document.querySelector('meta[name="description"]').setAttribute("content", destination.meta_description);
          document.querySelector('meta[name="keywords"]').setAttribute("content", destination.meta_keywords);
          next();
        })
        .catch(() => {
          next({ name: "404" });
        });
    }
  },
  reserveAreaRoutes,
  {
    path: "/ayuda",
    name: "help",
    component: require("../pages/PageFAQ.vue").default,
    meta: appConfig === 'avm'
      ? {
          title: languages.languages[lang].meta.help.avm.title,
          meta_title: languages.languages[lang].meta.help.avm.title,
          meta_description: languages.languages[lang].meta.help.avm.description,
        }
      : {
          title: languages.languages[lang].meta.help.ebm.title,
          meta_title: languages.languages[lang].meta.help.ebm.title,
          meta_description: languages.languages[lang].meta.help.ebm.description,
        }
  },
  {
    path: "/payment",
    name: "payment",
    component: require("../pages/PaymentSample.vue").default
  },
  {
    path: "/regala",
    name: "gift",
    component: require("../pages/gifts/GiftsLanding.vue").default,
    meta:{
      title: languages.languages[lang].meta.gifts.title,
      meta_title: languages.languages[lang].meta.gifts.title,
      meta_description: languages.languages[lang].meta.gifts.description,
    }
  },
  {
    path: "/regala/destinos",
    name: 'gifts-destinations',
    component: require('../pages/gifts/GiftsDestinations').default,
    meta:{
      title: languages.languages[lang].shared.avm_lower+' - '+languages.languages[lang].meta.meta_09,
      meta_title: languages.languages[lang].meta.meta_09,
      meta_description: languages.languages[lang].meta.meta_10 + ' ' + languages.languages[lang].meta.meta_16 + ' ' + languages.languages[lang].shared.avm_lower+' '+languages.languages[lang].meta.meta_17,
      meta_keywords: languages.languages[lang].meta.meta_19+', '+languages.languages[lang].shared.avm_upper+', '+ languages.languages[lang].meta.meta_18
    }
  },
  {
    path: "/regala/:slug/datos",
    name: 'gifts-form',
    component: require('../pages/gifts/GiftsForm').default
  },
  {
    path: "/regala/:code/confirmacion",
    name: 'gifts-confirmation',
    component: require('../pages/gifts/GiftsConfirmation').default,
  },
  {
    path: "/regala/:slug",
    name: "gifts-destination-details",
    component: require("../pages/gifts/GiftsDestinationDetails.vue").default,
    beforeEnter: async (to, from, next) => {
      if (from.name === 'gifts-destinations') {
        return next();
      }

      await store.dispatch(LOAD_GIFTS_LOCATIONS);
      const destination = store.getters[GIFTS_FIND_DESTINATION_FROM_SLUG](to.params.slug);

      if (destination) {
        const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);
        const capitalizedSlug = capitalizeFirstLetter(to.params.slug);
        document.title = `${languages.languages[lang].shared.avm_lower} - ${languages.languages[lang].meta.meta_08} ${capitalizedSlug}`;
        document.querySelector('meta[name="description"]').setAttribute("content", `${languages.languages[lang].meta.meta_15} ${languages.languages[lang].shared.to} ${capitalizedSlug}. ${languages.languages[lang].meta.meta_5}  ${languages.languages[lang].shared.avm_lower} ${languages.languages[lang].meta.meta_17}`);
        document.querySelector('meta[name="keywords"]').setAttribute("content", `${languages.languages[lang].meta.meta_19}, ${languages.languages[lang].shared.avm_upper}, ${languages.languages[lang].meta.meta_18}`);

        next();
      } else {
        next({ name: '404' });
      }
    }
  },
  {
    path: '/blog',
    name: 'blog-index',
    meta: appConfig === 'avm'
      ? {
          title: languages.languages[lang].meta.blog.avm.title,
          meta_title: languages.languages[lang].meta.blog.avm.title,
          meta_description: languages.languages[lang].meta.blog.avm.description,
        }
      : {
          title: languages.languages[lang].meta.blog.ebm.title,
          meta_title: languages.languages[lang].meta.blog.ebm.title,
          meta_description: languages.languages[lang].meta.blog.ebm.description,
        }
  },
  {
    path: '/blog/:slug',
    name: 'blog-show',
  },
  {
    path: '/politica-de-cookies',
    name: 'politica-de-cookies',
    meta:{
      title: languages.languages[lang].shared.avm_lower+' - '+languages.languages[lang].meta.meta_28,
      meta_description: languages.languages[lang].meta.meta_39,
    }
  },
  {
    path: '/aviso-legal',
    name: 'aviso-legal',
    meta:{
      title: languages.languages[lang].shared.avm_lower+' - '+languages.languages[lang].meta.meta_29,
      meta_title: languages.languages[lang].meta.meta_30,
      meta_description: languages.languages[lang].meta.meta_31+' '+languages.languages[lang].shared.avm_lower+', '+languages.languages[lang].meta.meta_32,
      meta_keywords: languages.languages[lang].meta.meta_33+', '+languages.languages[lang].shared.avm_upper+', '+languages.languages[lang].meta.meta_34
    }
  },
  {
    path: '/terminos-y-condiciones',
    name: 'terminos-y-condiciones',
    meta:{
      title: languages.languages[lang].shared.avm_lower+' - '+languages.languages[lang].footer.terms,
      meta_description: languages.languages[lang].meta.meta_40,
    }
  },
  {
    path: '/terminos-y-condiciones-cupones',
    name: 'terminos-y-condiciones-cupones',
    meta:{
      title: languages.languages[lang].shared.avm_lower+' - '+languages.languages[lang].footer.terms,
      meta_description: languages.languages[lang].meta.meta_41,
    }
  },
  {
    path: '/terminos-y-condiciones-flex',
    name: 'terminos-y-condiciones-flex',
    meta:{
      title: languages.languages[lang].shared.avm_lower+' - '+languages.languages[lang].footer.terms,
      meta_description: languages.languages[lang].meta.meta_42,
    }
  },
  {
    path: '/politica-de-privacidad',
    name: 'politica-de-privacidad',
    meta:{
      title: languages.languages[lang].shared.avm_lower+' - '+languages.languages[lang].footer.privacy_policy,
      meta_description: languages.languages[lang].meta.meta_43,
    }
  },
  {
    path: '/contacto',
    name: 'contact',
    meta: appConfig === 'avm'
    ? {
        title: languages.languages[lang].meta.contact.avm.title,
        meta_title: languages.languages[lang].meta.contact.avm.title,
        meta_description: languages.languages[lang].meta.contact.avm.description,
      }
    : {
        title: languages.languages[lang].meta.contact.ebm.title,
        meta_title: languages.languages[lang].meta.contact.ebm.title,
        meta_description: languages.languages[lang].meta.contact.ebm.description,
      }
  },
  {
    path: '/gestion/informes',
    name: 'reports',
    meta:{
      title: languages.languages[lang].shared.avm_lower+' - '+languages.languages[lang].meta.meta_36
    }
  },
  {
    path: '/gestion/calendario',
    name: 'admin.calendar',
    meta:{
      title: languages.languages[lang].shared.avm_lower+' - '+languages.languages[lang].meta.meta_37,
      meta_description: languages.languages[lang].meta.meta_45,
    }
  },
  {
    path: "*",
    name: "404",
    component: require("../pages/errors/404.vue").default,
    meta:{
      title: languages.languages[lang].shared.page_not_found
    }
  },
];

export default routes;
